'use client';

import { motion } from 'framer-motion';
import { ReactNode } from 'react';

interface AnimatedCardProps {
  children: ReactNode;
  className?: string;
  delay?: number;
  hover?: boolean;
  gradient?: boolean;
}

export function AnimatedCard({ children, className = '', delay = 0, hover = true, gradient = false }: AnimatedCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 15 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay, ease: 'easeOut' }}
      whileHover={hover ? { y: -2, boxShadow: '0 8px 30px -8px rgba(99, 102, 241, 0.12)' } : undefined}
      className={`
        bg-white rounded-xl border border-gray-100 shadow-sm 
        transition-all duration-200
        ${gradient ? 'bg-gradient-to-br from-white via-white to-indigo-50/30' : ''}
        ${className}
      `}
    >
      {children}
    </motion.div>
  );
}
